import { TriggerHistoryElement } from './TriggerHistoryElement';

export class AiTriggerElement extends TriggerHistoryElement {
  constructor() {
    super();
  }
}
